import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  changePage,
  changeGenrePage,
  changeLangPage
} from '../../../../action/VodAction';
import PropTypes from 'prop-types';
import { VODSearchColor } from '../../../../JS/setColors'

class GenreList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noImage: [],
    }
  }
  goBack = () => {
    if (this.props.callFromLang) {
      this.props.changeLangPage("", 0, false);
    } else {
      this.props.changePage(1);
    }
  }

  clickOnGenre = (pageNumber) => {
    this.props.changeGenrePage(pageNumber);
  }
  imageNotfound = (id) => {
    let noImageA = [...this.state.noImage];
    noImageA.push(id);
    //console.log("image not found.", noImageA);
    this.setState({ noImage: noImageA })
  }
  componentDidMount() {
    VODSearchColor(this.props.menuColor)
  }
  render() {
    return (
      <div id="movie-search-genre" className="movie-widgets">
        <div
          className="search-back"
          data-target="movie-widgets"
          onClick={this.goBack}
          style={{ color: "#ffffff" }}>
          <i className="fa fa-chevron-left" style={{ color: "inherit" }}></i>
          Back
         </div>
        <h4>Search movies by Genre</h4>
        <ul className="movie-widgets-list">
          {
            this.props.categoryOrder ?
              this.props.categoryOrder.map((iterator, index) => {
                return (
                  <li
                    style={this.state.noImage.indexOf(iterator.id) === -1 ? {
                      background: `url('${iterator.imageUrl}') center center no-repeat`,
                      backgroundSize: "cover"
                    } : null}
                    data-target="movie-genre-item"
                    onClick={() => { this.clickOnGenre(iterator.name) }}>
                    <img style={{ display: "none" }}
                      src={iterator.imageUrl}
                      alt="not found"
                      onError={() => {
                        this.imageNotfound(iterator.id);
                      }} />
                    {
                      this.state.noImage.indexOf(iterator.id) !== -1 ?
                        <a><i class="fa fa-video-camera"></i></a> : null
                    }
                    <span className="movie-thumb-text">{iterator.name}</span>
                  </li>
                )
              })
              : null
          }
        </ul>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    callFromLang: state.store.vod.lang.callFromLang,
    categoryOrder: state.store.vod.VODData ?
      state.store.vod.VODData.channelCategoryOrder : null,
    menuColor: state.store.home.MenuColor
  }
}

export default connect(
  mapStateToProps, {
  changePage,
  changeGenrePage,
  changeLangPage
}
)(GenreList);